export default __webpack_public_path__ + "static/media/4.1e77932e.jpg";